<template>
  <div id="aba-dados-principais">
    <card v-if="loading">
      <small-loading :loading="true"></small-loading>
    </card>

    <template v-else>
      <card titulo="Registro de Título">
        <card-content>

          <p>
            <span class="font-weight-500">Situação: </span><span>{{status.find(s => s.id === ficha.status).nome}}</span>
          </p>

          <p v-if="ficha.origem != null">
            <span class="font-weight-500">Registro Anterior: </span><span class="icon" @click.prevent="detalhesRegistro(ficha.origem)">{{nomearFicha(ficha.origem)}} - {{tipoRegistroAnterior}}</span>
          </p>

          <p v-if="ficha.cadastro">
            <span class="font-weight-500">Cadastro: </span><span>{{ficha.cadastro | datahora}}</span>
          </p>

          <p v-if="ficha.abertura">
            <span class="font-weight-500">Abertura: </span><span>{{ficha.abertura | datahora}}</span>
          </p>

          <p v-if="ficha.encerramento && (ficha.status === 'ENCERRADA' || ficha.status === 'CANCELADA' || ficha.status === 'ANULADA')">
            <span v-if="ficha.status === 'ENCERRADA'" class="font-weight-500">Encerramento: </span><span v-if="ficha.status === 'CANCELADA'" class="font-weight-500">Cancelamento: </span><span v-if="ficha.status === 'ANULADA'" class="font-weight-500">Anulação: </span><span>{{ficha.encerramento | datahora}}</span>
          </p>

        </card-content>
      </card>

      <card titulo="Identificação" v-if="ficha.livroLetra">
        <card-content>
          <p v-if="ficha.livroLetra">
            <span class="font-weight-500">Livro (Letra): </span><span>{{ficha.livroLetra}}</span>
          </p>

        </card-content>
      </card>

      <card titulo="Observações" v-if="ficha.observacoes">
        <card-content>
          <div v-html="ficha.observacoes" v-inline-font></div>
        </card-content>
      </card>

      <informacoes-livro :tipo-registro="tipoRegistro" :ficha="ficha.id" />

      <card titulo="Envolvidos" v-if="envolvidos && envolvidos.length">

        <table class="table table-striped card-table table-vcenter">

          <thead>
          <tr>
            <th class="pl-2">PESSOA</th>
            <th>DOCUMENTO</th>
            <th class="text-right pr-2">PAPEL</th>
          </tr>
          </thead>

          <tbody>
          <tr v-for="(envolvido, index) in envolvidos" :key="index+envolvido.indicadorPessoalVersaoId">
            <td class="pl-2">
              <a href class="mb-1 pointer" @click.prevent="detalhes(envolvido.indicadorPessoalVersaoId)">{{envolvido.nome}}{{ versionamentoAtivo && envolvido.versao != null ? ` (Versão: ${envolvido.versao})` : '' }}</a>
            </td>
            <td class="nowrap">{{envolvido.documento}}</td>
            <td class="nowrap text-right pr-2">{{nomePapel(envolvido.papel)}}</td>
          </tr>
          </tbody>

        </table>

      </card>

      <card titulo="Bens Vinculados" v-if="bensMoveis && bensMoveis.length">
        <table class="table table-striped card-table table-vcenter">
          <thead>
          <tr>
            <th class="pl-2">BEM  MÓVEL</th>
            <th class="text-right pr-2">VALOR DA GARANTIA</th>
          </tr>
          </thead>

          <tbody>
          <tr v-for="(bens, i) in bensMoveis" :key="i">
            <td class="pl-2 d-flex flex-column">
              <a href @click.prevent="detalhesBensMoveis(bens.id)">{{nomearFicha(bens)}}</a>
              <span class="small text-muted">{{bens.tipoBem}} - {{bens.nomeBem}}</span>
            </td>
            <td class="text-right pr-2">{{bens.valor | moeda}}</td>
          </tr>
          </tbody>
        </table>
      </card>

    </template>

  </div>
</template>

<script>
  import FrontBusiness from "@/business/FrontBusiness";
  import businessTipoServico from "@/views/Administracao/modulos/tipo-servico/business.js";
  import RegistroTDBusiness from "@/business/indicadores/RegistroTDBusiness.js";
  import RegistroPJBusiness from "@/business/indicadores/RegistroPJBusiness";
  import DetalhesIndicadorPessoal from "@/components/IndicadorPessoal/Detalhes/DetalhesIndicadorPessoal";
  import Card from "@/components/Layout/components/Card.vue";
  import CardContent from "@/components/Layout/components/CardContent.vue";
  import SmallLoading from "@/components/SmallLoading";
  import DetalhesRegistroTD from "@/components/RegistroTitulo/Detalhes/DetalhesRegistroTD.vue";
  import DetalhesRegistroPJ from "@/components/RegistroPJ/Detalhes/DetalhesRegistroPJ.vue";
  import DetalhesIndicadorReal from "@/components/IndicadorReal/Detalhes/DetalhesIndicadorReal.vue";
  import DetalhesBemMovel from "@/components/BemMovel/Detalhes/DetalhesBemMovel.vue";
  import IndicadorAbstractService from "@/business/indicadores/IndicadorAbstractService";
  import InformacoesLivro from "@/components/IndicadorGeneric/Detalhes/InformacoesLivro.vue";

  export default {

    name: "Dados",
    components: {InformacoesLivro, CardContent, Card, SmallLoading},
    props: {
      id: String,
    },

    data() {
      return {
        bensMoveis: [],
        documentos: [],
        envolvidos : [],
        ficha : [],
        loading : true,
        status: RegistroTDBusiness.getStatusImovel(),
        tipoRegistroAnterior: ''
      }
    },

    async mounted() {
      this.loading = true;
      try {
        await Promise.all([
          RegistroTDBusiness.getById(this.id).then(r => this.ficha = r),
          RegistroTDBusiness.getEnvolvidos(this.id).then(r => this.envolvidos = r),
          RegistroTDBusiness.getBensMoveisVinculados(this.id).then(r => this.bensMoveis = r),
          IndicadorAbstractService.getDocumentosVinculados(this.id).then(r => this.documentos = r)
        ]);

        if (this.ficha.origem != null) {
          const origem = this.ficha.origem;
          if (origem.livro === 'REGISTRO_PJ') {
            this.tipoRegistroAnterior = RegistroPJBusiness.getTipos().find(t => t.id === origem.tipoRegistro)?.nome;
          } else {
            this.tipoRegistroAnterior = RegistroTDBusiness.getTipos().find(t => t.id === origem.tipoRegistro)?.nome;
          }
        }
      } finally {
        this.loading = false;
      }
    },

    computed:{
      tipoRegistro(){
        return RegistroTDBusiness.getTipos().find(t => t.id === this.ficha.tipoRegistro)?.nome;
      },
      versionamentoAtivo(){
        return !this.$root?.config?.geral?.desativarVersionamentoPessoas;
      },
    },

    methods:{
      nomePapel(papel){ return businessTipoServico.nomePapel(papel) },

      detalhes(versao){
        FrontBusiness.openModal(DetalhesIndicadorPessoal, {versao});
      },

      detalhesBensMoveis(bem){
        FrontBusiness.openModal(DetalhesBemMovel, {id: bem})
      },

      nomearFicha(ficha){
        return FrontBusiness.nomearFicha(ficha);
      },

      detalhesRegistro(origem) {
        if (!origem?.livro) {
          FrontBusiness.openModal(DetalhesRegistroTD, {id: origem.id});
          return;
        }
        switch (origem.livro) {
          case 'REGISTRO_TD':
            FrontBusiness.openModal(DetalhesRegistroTD, {id: origem.id});
            break;
          case 'REGISTRO_PJ':
            FrontBusiness.openModal(DetalhesRegistroPJ, {id: origem.id});
            break;
          default:
            FrontBusiness.openModal(DetalhesIndicadorReal, {id: origem.id});
        }
      },
    }
  }
</script>
